export default __webpack_public_path__ + "static/media/Grinning5.ba8f3378.svg";